import { LockOpen, Lock, X } from '@phosphor-icons/react';
import { ClipLoader } from 'react-spinners';
import { DebitCardWithTruck } from '../../../../../../../types/apiTypes';

function CardActionsMenu({
  popupRef,
  currCard,
  loadingFreeze,
  loadingCancel,
  setPopupVisible,
  setNewCardPopupVisible,
  setActivateCardPopupVisible,
  freezeCard,
  cancelCard,
}: {
  popupRef: React.RefObject<HTMLDivElement>;
  currCard: DebitCardWithTruck | null;
  loadingFreeze: boolean;
  loadingCancel: boolean;
  setPopupVisible: (visible: boolean) => void;
  setNewCardPopupVisible: (visible: boolean) => void;
  setActivateCardPopupVisible: (visible: boolean) => void;
  freezeCard: (cardId: string, freeze: boolean) => Promise<void>;
  cancelCard: (cardId: string, last_four_digits: string) => void;
}) {
  return (
    <div
      ref={popupRef}
      className="absolute right-0 top-[2.85rem] z-[999] w-56 rounded-lg border-[1px] border-bordergray bg-white shadow-lg drop-shadow-xl"
    >
      <div className="flex flex-col">
        {currCard?.physical_card_activated_timestamp === null && (
          <button
            onClick={(e: any) => {
              e.stopPropagation();
              setPopupVisible(false);
              setActivateCardPopupVisible(true);
            }}
            className="flex w-full flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-orange-600 hover:bg-gray-100"
          >
            <img
              alt="card-add"
              src="/card-tick.svg"
              className="h-[20px] w-[20px]"
              style={{
                filter:
                  'invert(30%) sepia(100%) saturate(800%) hue-rotate(359deg) brightness(97%) contrast(101%)',
              }}
            />
            <p>Activate Physical Card</p>
          </button>
        )}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setPopupVisible(false);
            setNewCardPopupVisible(true);
          }}
          className="flex w-full flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-primary hover:bg-gray-100"
        >
          <img
            alt="card-add"
            src="/card-add.svg"
            className="h-[20px] w-[20px]"
          />
          <p>Add New Card</p>
        </button>
        {!currCard?.frozen ? (
          <button
            onClick={async (e) => {
              e.stopPropagation();
              await freezeCard(currCard?.debit_card_id ?? '', true);
              setPopupVisible(false);
            }}
            className="flex w-full flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-primary hover:bg-gray-100"
          >
            <Lock size={20} />
            <p>Freeze Debit Card</p>
            {loadingFreeze && (
              <ClipLoader
                color="#1D213B"
                loading={loadingFreeze}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
                className="h-full w-full justify-center"
              />
            )}
          </button>
        ) : (
          <button
            onClick={async (e) => {
              e.stopPropagation();
              await freezeCard(currCard?.debit_card_id ?? '', false);
              setPopupVisible(false);
            }}
            className="flex w-full flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-primary hover:bg-gray-100"
          >
            <LockOpen size={20} />
            <p>Unfreeze Debit Card</p>
            {loadingFreeze && (
              <ClipLoader
                color="#1D213B"
                loading={loadingFreeze}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
                className="h-full w-full justify-center"
              />
            )}
          </button>
        )}
        <button
          onClick={async (e) => {
            e.stopPropagation();
            await cancelCard(
              currCard?.debit_card_id ?? '',
              currCard?.last_four_digits ?? ''
            );
            setPopupVisible(false);
          }}
          className="flex w-full flex-row items-center space-x-1 rounded-lg px-4 py-2 text-left align-middle text-danger hover:bg-gray-100"
        >
          <X
            size={20}
            className="h-[20px] min-h-[20px] w-[20px] min-w-[20px]"
          />
          <p>Cancel Card</p>
          {loadingCancel && (
            <ClipLoader
              color="#1D213B"
              loading={loadingCancel}
              size={20}
              aria-label="Loading Spinner"
              data-testid="loader"
              className="h-full w-full justify-center"
            />
          )}
        </button>
      </div>
    </div>
  );
}

export default CardActionsMenu;
